import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Container, Grid, Paper, Typography } from '../../../components/mui/Core/index'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import { CustomerGroupAccountTable } from './components/CustomerGroupTable/customer-group-account-table'
import { fetchCustomerGroupAccount, fetchCustomerSpecialPricing } from './customer-group-slice'
import GenericSnackbar from '../../../components/GenericSnackbar/generic-snackbar'
import { setSnackbar } from '../../../components/GenericSnackbar/generic-snackbar-slice'
import GroupSpecialPricingTable from './components/GroupSpecialPricingTable/group-special-pricing-table'
import useBrowserTabTitles from '../../../hooks/browserTabTitles/browser-tab-titles'
import PageTitle from '../../../components/PageTitle/page-title'
import Constants from '../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

function CustomerGroup() {
  const selectedCustomerGroup = useSelector((state) => state.customerGroup.selectedCustomerGroup)
  const dispatch = useDispatch()
  const fetchCustomerGroupAccountError = useSelector(
    (state) => state.customerGroup.fetchCustomerGroupAccountError,
  )
  const fetchCustomerSpecialPricingError = useSelector(
    (state) => state.customerGroup.fetchCustomerSpecialPricingError,
  )
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const pageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${selectedCustomerGroup?.customerGroupName}`
    : selectedCustomerGroup?.customerGroupName
  const browserTabTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${selectedCustomerGroup?.customerGroupName} ${Constants.itemSpecialPricing.PRICING_GROUP}`
    : `${selectedCustomerGroup?.customerGroupName} ${Constants.itemSpecialPricing.PRICING_GROUP}`
  useBrowserTabTitles(browserTabTitle)

  useEffect(() => {
    if (selectedCustomerGroup) {
      dispatch(fetchCustomerGroupAccount(selectedCustomerGroup?.id))
      dispatch(fetchCustomerSpecialPricing(selectedCustomerGroup?.id))
    }
  }, [dispatch, selectedCustomerGroup])

  useEffect(() => {
    if (fetchCustomerGroupAccountError) {
      dispatch(
        setSnackbar({
          message: JSON.stringify(fetchCustomerGroupAccountError.message),
          severity: 'error',
          action: true,
        }),
      )
    }
    if (fetchCustomerSpecialPricingError) {
      dispatch(
        setSnackbar({
          message: JSON.stringify(fetchCustomerSpecialPricingError.message),
          severity: 'error',
          action: true,
        }),
      )
    }
  }, [fetchCustomerGroupAccountError, fetchCustomerSpecialPricingError, dispatch])

  return (
    <Box sx={{ flexGrow: 1 }}>
      <GenericNav selected='Inventory' user='authenticated' />
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <PageTitle title={pageTitle} />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ py: 5 }}>
            <CustomerGroupAccountTable />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ py: 5 }}>
            <Box sx={{ py: 1 }}>
              <Typography variant='cardHeader' sx={{ pt: 4, mb: 1 }}>
                Special Pricing
              </Typography>
            </Box>
            <GroupSpecialPricingTable />
          </Grid>
        </Grid>
        <Paper sx={{ width: '100%', mb: 2 }} />
      </Container>
      <GenericSnackbar />
    </Box>
  )
}

export default CustomerGroup
